import React, { useState } from 'react';
import { PlusIcon, XMarkIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import DropdownCustom from '../../../moduleComponents/DropdownCustom';
import { getL1Options, getL2Options, buildL0Key } from '../../../moduleServices/helper_hierarchicalCategory';

const CardBudgetAddL1 = ({ l0Label, hierarchicalCategories = {}, onCreateL1Block, isVisibleL2 = true, onToggleVisibility }) => {
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({
    budget_type: 'Out',
    class_l1: '',
    class_l2: '',
  });

  const handleChange = (field, value) => {
    if (field === 'budget_type') {
      setForm(prev => ({ ...prev, budget_type: value, class_l1: '', class_l2: '' }));
    } else if (field === 'class_l1') {
      const l1Value = typeof value === 'object' ? value.value : value;
      setForm(prev => ({ ...prev, class_l1: l1Value, class_l2: '' }));
    } else if (field === 'class_l2') {
      const l2Value = typeof value === 'object' ? value.value : value;
      setForm(prev => ({ ...prev, class_l2: l2Value }));
    } else {
      setForm(prev => ({ ...prev, [field]: value }));
    }
  };

  const handleCreate = () => {
    if (!form.class_l1) return;
    
    const l1Label = hierarchicalCategories.by_l1?.[form.class_l1]?.name || '';
    const l2Label = form.class_l2 ? (hierarchicalCategories.by_l2?.[form.class_l2]?.name || '') : '';
    
    onCreateL1Block && onCreateL1Block({
      budget_type: form.budget_type,
      class_l1: l1Label,
      class_l2: l2Label
    });
    setForm({ budget_type: 'Out', class_l1: '', class_l2: '' });
    setAdding(false);
  };

  const typeOptions = [
    { value: 'Out', label: 'Out' },
    { value: 'In', label: 'In' }
  ];
  
  const l0Key = l0Label ? buildL0Key(l0Label, form.budget_type) : '';
  const l1Options = getL1Options(hierarchicalCategories, l0Key);
  const l2Options = getL2Options(hierarchicalCategories, form.class_l1);

  return (
    <>
      <div className="flex justify-end gap-2 mb-2">
        <button onClick={() => setAdding(true)} className="flex items-center gap-1 text-green-700 hover:bg-green-100 px-3 py-1 rounded transition font-semibold text-xs">
          <PlusIcon className="h-4 w-4" /> Add Category
        </button>
        <button
          className="text-gray-600 hover:bg-gray-200 rounded px-2 py-1 flex items-center"
          title={isVisibleL2 ? "Hide all entries" : "Show all entries"}
          aria-label={isVisibleL2 ? "Hide all entries" : "Show all entries"}
          onClick={onToggleVisibility}
        >
          {isVisibleL2 ? <EyeIcon className="w-4 h-4" /> : <EyeSlashIcon className="w-4 h-4" />}
        </button>
      </div>
      {adding && (
        <div className="bg-gray-100 rounded-lg px-2 py-2 my-2">
          <div className="flex items-center gap-2 mb-2">
            <DropdownCustom
              options={typeOptions}
              selectedValue={form.budget_type}
              onSelect={option => handleChange('budget_type', typeof option === 'object' ? option.value : option)}
              placeholder="Type"
              width="w-16"
            />
            <div className="flex-1">
              <DropdownCustom
                options={l1Options}
                selectedValue={form.class_l1}
                onSelect={option => handleChange('class_l1', option)}
                placeholder="Category"
                width="w-full"
              />
            </div>
            <div className="flex-1">
              <DropdownCustom
                options={l2Options}
                selectedValue={form.class_l2}
                onSelect={option => handleChange('class_l2', option)}
                placeholder="Sub-Category"
                width="w-full"
                disabled={!form.class_l1}
              />
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <button
              className="bg-green-800 text-white px-4 py-1.5 rounded hover:bg-green-900 text-xs"
              onClick={handleCreate}
              disabled={!form.class_l1}
              type="button"
            >
              Create
            </button>
            <button
              className="text-gray-500 px-2 py-1 rounded hover:bg-gray-200 text-xs flex items-center"
              onClick={() => { setAdding(false); setForm({ budget_type: 'Out', class_l1: '', class_l2: '' }); }}
              type="button"
              aria-label="Cancel"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CardBudgetAddL1;
